import { useEffect, useState,Dispatch } from 'react';

/*type UseLocalStorage = <T extends any>(key: string, defaultValue: T) => [T, Dispatch<T>]*/

const getStorageValue = (key: string, defaultValue: any) => {
  if (typeof window !== 'undefined') {
    const saved = localStorage.getItem(key);
    try {
      return saved !== null ? JSON.parse(saved) : defaultValue;
    } catch (e) {
      return defaultValue;
    }
  }
};

//Хук чтения из localstorage JSON
export const useLocalStorage= (key: string, defaultValue: any) => {
  const [value, setValue] = useState(() => {
    return getStorageValue(key, defaultValue);
  });

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue];
};



const getStorageSimpleValue = (key: string, defaultValue: any) => {
  if (typeof window !== 'undefined') {
    const saved = localStorage.getItem(key);
    try {
      return saved !== null ? saved : defaultValue;
    } catch (e) {
      return defaultValue;
    }
  }
};

//Хук чтения из localstorage обычного, не JSON формата
export const useLocalStorageSimple= (key: string, defaultValue: any) => {
  const [value, setValue] = useState(() => {
    return getStorageSimpleValue(key, defaultValue);
  });

  useEffect(() => {
    localStorage.setItem(key, value);
  }, [key, value]);

  return [value, setValue];
};
